import { useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import { Check, MessageCircle, ArrowLeft } from "lucide-react";
import { INQUIRY, TRACKING } from "../config/content";
import { confirmationWhatsAppLink } from "../lib/api";
import { Logo } from "../components/Navbar";

function fireMetaPixel() {
  const pid = TRACKING.metaPixelId;
  if (!pid || pid.startsWith("[")) return false;
  const w = window;
  if (!w.fbq) {
    const n = (w.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); });
    n.queue = [];
    n.loaded = true;
    n.version = "2.0";
    const t = document.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(t);
  }
  w.fbq("init", pid);
  w.fbq("track", "Lead");
  return true;
}

export default function ThankYou() {
  const lead = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("marubazu_lead") || "{}");
    } catch { return {}; }
  }, []);

  useEffect(() => {
    fireMetaPixel();
  }, []);

  const firstName = (lead.name || "Trader").trim().split(" ")[0];

  return (
    <div className="min-h-screen bg-[#070A08] flex flex-col" data-testid="thank-you-page">
      <header className="border-b border-[#17231B] py-4">
        <div className="max-w-[1180px] mx-auto px-4 sm:px-6"><Logo size="text-xl" /></div>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="text-center max-w-md">
          <motion.div
            initial={{ scale: 0.4, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: "spring", stiffness: 220, damping: 14 }}
            className="mx-auto w-20 h-20 rounded-full bg-[#22C55E]/15 border border-[#22C55E]/50 flex items-center justify-center shadow-[0_0_50px_-8px_rgba(34,197,94,0.6)]"
          >
            <Check className="w-10 h-10 text-[#22C55E]" strokeWidth={3} />
          </motion.div>
          <h1 className="mt-6 font-heading uppercase text-white text-5xl tracking-wide" data-testid="thank-you-title">
            {INQUIRY.thankYou.title.replace("{firstName}", firstName)}
          </h1>
          <p className="mt-4 text-base text-[#A7B3AA] leading-relaxed" data-testid="thank-you-text">{INQUIRY.thankYou.text}</p>
          <a
            href={confirmationWhatsAppLink({ name: lead.name || "there", city: lead.city || "", experience: lead.experience || "", problems: lead.problems || [] })}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="thank-you-whatsapp-button"
            className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-[#22C55E] hover:bg-[#16A34A] text-[#04100A] font-extrabold text-base px-8 py-4 transition-colors"
          >
            <MessageCircle className="w-5 h-5" />
            {INQUIRY.thankYou.whatsapp}
          </a>
          <p className="mt-6 text-xs text-[#6B7A70]">{INQUIRY.thankYou.smallLine}</p>
          <a href="/" data-testid="thank-you-home-link" className="mt-8 inline-flex items-center gap-2 text-sm text-[#A7B3AA] hover:text-[#22C55E] transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Marubazu
          </a>
        </div>
      </main>
    </div>
  );
}
